import React from "react";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const WD = ["S", "M", "T", "W", "T", "F", "S"];

const pad = (n) => String(n).padStart(2, "0");

const MonthGrid = ({ year, month, eventDates, today, onSelectDate }) => {
  const first = new Date(year, month, 1).getDay();
  const days = new Date(year, month + 1, 0).getDate();
  const cells = [];
  for (let i = 0; i < first; i++) cells.push(null);
  for (let d = 1; d <= days; d++) cells.push(d);

  return (
    <div className="rounded-2xl border border-white/10 bg-[#101017] p-4" data-testid={`calendar-month-${month}`}>
      <h4 className="font-serif text-lg text-champagne mb-3">{MONTHS[month]}</h4>
      <div className="grid grid-cols-7 gap-y-1 text-center">
        {WD.map((w, i) => <span key={i} className="text-[9px] text-slate-600 font-medium">{w}</span>)}
        {cells.map((d, i) => {
          if (!d) return <span key={i} />;
          const ds = `${year}-${pad(month + 1)}-${pad(d)}`;
          const hasEvent = eventDates.has(ds);
          const isToday = ds === today;
          return (
            <button
              key={i}
              onClick={() => onSelectDate(ds)}
              data-testid={`calendar-day-${ds}`}
              className={`relative mx-auto w-7 h-7 rounded-full text-[11px] flex items-center justify-center transition-colors duration-150
                ${isToday ? "bg-gradient-to-r from-[#F3E5AB] to-[#D4AF37] text-[#1a1a12] font-semibold" : hasEvent ? "text-champagne bg-amber-400/15" : "text-slate-300 hover:bg-white/5"}`}
            >
              {d}
              {hasEvent && !isToday && <span className="absolute bottom-0.5 w-1 h-1 rounded-full bg-amber-400" />}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export const YearCalendar = ({ year, events = [], onSelectDate }) => {
  const eventDates = new Set(events.map((e) => e.date));
  const today = new Date().toISOString().slice(0, 10);
  return (
    <div data-testid="year-calendar">
      <div className="flex items-baseline gap-3 mb-6">
        <h2 className="font-serif text-4xl gold-gradient-text">{year}</h2>
        <span className="text-sm text-slate-500">Tap any date to add a business date</span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {MONTHS.map((_, m) => (
          <MonthGrid key={m} year={year} month={m} eventDates={eventDates} today={today} onSelectDate={onSelectDate} />
        ))}
      </div>
    </div>
  );
};
